var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{attrs:{"trigger":"hover","options":{
placement: 'top',
modifiers: { offset: { offset: '0,10px' } }
}}},[_c('div',{staticClass:"popper"},[_vm._v(" "+_vm._s(_vm.txt)),(_vm.url)?_c('br'):_vm._e(),(_vm.url)?_c('a',{attrs:{"href":_vm.url}},[_vm._v("En savoir plus")]):_vm._e()]),_c('i',{staticClass:"pi pi-info-circle",staticStyle:{"margin-left":"10px"},attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }